import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import AdminGate from '../components/admin/AdminGate';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const AdminProducts = lazy(() => import('../pages/admin/products/page'));
const AdminImages = lazy(() => import('../pages/admin/images/page'));
const AdminNews = lazy(() => import('../pages/admin/news/page'));
const AdminContacts = lazy(() => import('../pages/admin/contacts/page'));
const Products = lazy(() => import('../pages/products/page'));
const Hiace = lazy(() => import('../pages/hiace/page'));
const Probox = lazy(() => import('../pages/probox/page'));
const ProductDetail = lazy(() => import('../pages/product/page'));
const Campaign = lazy(() => import('../pages/campaign/page'));
const About = lazy(() => import('../pages/about/page'));
const NewsList = lazy(() => import('../pages/news/page'));
const NewsDetail = lazy(() => import('../pages/news/detail'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Commerce = lazy(() => import('../pages/commerce/page'));
const Contact = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/hiace', element: <Hiace /> },
  { path: '/probox', element: <Probox /> },
  { path: '/about', element: <About /> },
  { path: '/admin/products', element: <AdminGate><AdminProducts /></AdminGate> },
  { path: '/admin/images', element: <AdminGate><AdminImages /></AdminGate> },
  { path: '/admin/news', element: <AdminGate><AdminNews /></AdminGate> },
  { path: '/admin/contacts', element: <AdminGate><AdminContacts /></AdminGate> },
  { path: '/products', element: <Products /> },
  { path: '/product', element: <Navigate to="/products" replace /> },
  { path: '/product/', element: <Navigate to="/products" replace /> },
  { path: '/product/:id', element: <ProductDetail /> },
  { path: '/campaign/:id', element: <Campaign /> },
  { path: '/news', element: <NewsList /> },
  { path: '/news/:id', element: <NewsDetail /> },
  { path: '/privacy', element: <Privacy /> },
  { path: '/commerce', element: <Commerce /> },
  { path: '/contact', element: <Contact /> },
  { path: '*', element: <NotFound /> },
];

export default routes;